import React, { MouseEventHandler, useState } from 'react';
import { Dropdown } from 'antd';

import IbIcon from '../../IbIcon';
import StatusSteps from '../StatusSteps';
import { IStatusInfoItem, StatusInfoState, StatusInfoTheme } from '../types';

import './index.less';
import { BUTTON_CLASS_NAME, ICON_CLASS_NAME, MAIN_CLASS_NAME, OVERLAY_CLASS_NAME, TITLE_CLASS_NAME } from './const';

export interface IStatusDropdownProps {
  className?: string;
  rolling: boolean;
  items: IStatusInfoItem[];
  current?: number;
  theme?: StatusInfoTheme;
  status?: StatusInfoState;
  onClick?: MouseEventHandler<HTMLElement>;
  onRestart?: () => void;
}

const StatusDropdown: React.FC<IStatusDropdownProps> = ({
  className,
  rolling,
  items,
  current,
  theme,
  status,
  onClick,
  onRestart,
}) => {
  const [opened, setOpened] = useState(false);

  const onButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(e);
  };

  const onOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    setOpened(false);
    onClick?.(e);
  };

  const onVisibleChange = (visible: boolean) => {
    setOpened(visible);
  };

  const onStepsRestart = () => {
    if (rolling) {
      return;
    }

    setOpened(false);
    onRestart?.();
  };

  const renderIcon = () => {
    if (status === StatusInfoState.Process) {
      return <IbIcon spin className={ICON_CLASS_NAME} iconName="loading-four" size={16} />;
    }

    if (status === StatusInfoState.Finish) {
      return <IbIcon className={ICON_CLASS_NAME} iconName="check-one" size={16} />;
    }

    if (status === StatusInfoState.Error) {
      return <IbIcon className={ICON_CLASS_NAME} iconName="handle-x" size={16} />;
    }

    return <IbIcon className={ICON_CLASS_NAME} iconName="round" size={16} />;
  };

  const renderTitle = () => {
    const title = current ? items[current].title : items[0].title;
    return (
      <div className={TITLE_CLASS_NAME} title={title}>
        {title}
      </div>
    );
  };

  const renderArrow = () => {
    const iconName = opened ? 'up' : 'down';
    return <IbIcon iconName={iconName} size={20} />;
  };

  const renderButton = () => {
    const classes = [
      BUTTON_CLASS_NAME,
      `${BUTTON_CLASS_NAME}_${theme || StatusInfoTheme.Green}`,
      `${BUTTON_CLASS_NAME}_${status || StatusInfoState.Wait}`,
    ];
    return (
      <button className={classes.join(' ')} onClick={onButtonClick}>
        {renderIcon()}
        {renderTitle()}
        {renderArrow()}
      </button>
    );
  };

  const renderOverlay = () => {
    return (
      <div className={OVERLAY_CLASS_NAME} onClick={onOverlayClick}>
        <StatusSteps
          current={current}
          direction="vertical"
          items={items}
          rolling={rolling}
          status={status}
          theme={theme}
          onRestart={onStepsRestart}
        />
      </div>
    );
  };

  const statuses = [MAIN_CLASS_NAME];
  if (className) {
    statuses.push(className);
  }

  return (
    <Dropdown
      className={statuses.join(' ')}
      overlay={renderOverlay()}
      trigger={['click']}
      onVisibleChange={onVisibleChange}
    >
      {renderButton()}
    </Dropdown>
  );
};

export default StatusDropdown;
